<div class="coupon-card-vip-root" *transloco="let t">
  <div class="content">
    <div class="header">
      <div class="business-data">
        <app-rounded-image xxsmall [src]="businessImgBase64"></app-rounded-image>
        <span class="business-name"
              [matTooltip]="businessName.length > 50 ? businessName : ''"
              matTooltipClass="name-tooltip">
          {{ businessName }}
        </span>
        <span class="business-vip"> - {{ vipLevel }}</span>
      </div>
    </div>
    <div class="dashed-line"></div>
    <div class="center">
      <div class="rewards-data">
        <div class="grid-item">
          <span class="grid-title">{{ t('ink-discount-models') }}</span>
          <div class="model-value">{{ uniqueModel | transloco }}</div>
        </div>
        <div class="grid-item">
          <span class="grid-title">{{ t('reseller') }}</span>
          <div class="value">{{ resellerName }}</div>
        </div>
        <div class="grid-item">
          <span class="grid-title">{{ t('discount-value') }}</span>
          <div class="value">{{ discountValue }}%</div>
        </div>
        <div class="grid-item">
          <span class="grid-title">{{ t('issued-date') }}</span>
          <div class="value">{{ startingDate | date : 'd MMM y' : '' : language }}</div>
        </div>
      </div>
    </div>
    <span class="title-code">
      {{ t('discount-code') }}
    </span>
    <span class="code">
      {{ couponCode }}
    </span>
    <span class="country" *ngIf="countryName">
      {{ t('coupon-valid-country', { countryName: countryName }) }}
    </span>
    <span class="special-promo">
      {{ configSeriesDisclaimer }}
    </span>
    <div class="dashed-line"></div>
    <div class="bottom-area">
      <app-chip id="expiration-info" defaultCursor small filled [lightgray]="!active" [green]="active">
        {{ statusCheck | transloco }}
        {{ expirationDate | date : 'd MMM y' : '' : language }}
      </app-chip>
    </div>
  </div>
</div>
